"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _anyToKebab = _interopRequireDefault(require("./any-to-kebab"));

var _isRunningOnClient = _interopRequireDefault(require("./is-running-on-client"));

var _kebabToCamel = _interopRequireDefault(require("./kebab-to-camel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getData(dataAttributeName) {
  if (!_isRunningOnClient["default"]) {
    return;
  }

  var kebabedName = (0, _anyToKebab["default"])(dataAttributeName);
  var node = document.querySelector("[data-".concat(kebabedName, "]"));

  if (!node) {
    return;
  }

  return node.dataset[(0, _kebabToCamel["default"])(kebabedName)];
}

var _default = getData;
exports["default"] = _default;